<template>
    <div class="wrap">
        <div class="header-wrap">
            <div class="header">
                <div class="logo">
                    <a @click="$router.replace({name:'lgindex'})"><img src="@/assets/images/logo1.png" alt="联合信任" /></a>
                    <a class="ngb" href="https://www.ngb.co.jp/" target="_blank"><img src="@/assets/images/ngb-logo.png" alt="联合信任" width="72" /></a>
                </div>
            </div>
        </div>
        <div class="banner">
            <img src="@/assets/images/banner.png" alt="banner">
        </div>
        <div class="reg-cnt">
            <div class="reg-body">
                <div class="logo2">
                    <img src="@/assets/images/logo3.png" alt />
                    <p>トラステッド・タイムスタンプ</p>
                </div>
                <div class="pageName">
                    <h3>トライアル・アカウントの登録</h3>
                    <p>注:会社名、会社法人等番号はタイムスタンプの申請に必要な情報ですので、正確にご記入ください。</p>
                </div>
                <div class="form">
                    <el-form
                        class="demo-ruleForm"
                        :model="applyForm"
                        :rules="applyRules"
                        ref="applyForm"
                    > 
                        <el-form-item label="会社名" prop="realName">
                            <el-input type="text" v-model="applyForm.realName" id="realName" placeholder="会社名を入力してください"></el-input>
                        </el-form-item>
                        <el-form-item label="会社法人等番号" prop="identityId">
                            <el-input type="text" v-model="applyForm.identityId" id="identityId" placeholder="１２桁の会社法人等番号を入力してください"></el-input>
                        </el-form-item>
                        <el-form-item label="ユーザーID" prop="loginName">
                            <el-input type="text" v-model="applyForm.loginName" id="loginName" placeholder="3－20桁のユーザーIDをご記入ください。数字、英字の大文字と小文字、または「-」を含むことができます"></el-input>
                        </el-form-item>
                        <el-form-item label="パスワード" prop="password">
                            <el-input type="text" v-model="applyForm.password" id="password" show-password placeholder="6－20桁の数字又は英字を含むパスワードを設定してください"></el-input>
                        </el-form-item>
                        <el-form-item label="パスワードの確認" prop="confirmPassword">
                            <el-input type="text" v-model="applyForm.confirmPassword" id="confirmPassword" show-password placeholder="パスワードを再入力してください"></el-input>
                        </el-form-item>
                        <el-form-item label="担当者氏名" prop="contactName">
                            <el-input type="text" v-model="applyForm.contactName" id="contactName" placeholder="担当者氏名を入力してください"></el-input>
                        </el-form-item>
                        <el-form-item label="連絡先メールアドレス" prop="email">
                            <el-input type="text" v-model="applyForm.email" id="email" placeholder="メールアドレスを入力してください"></el-input>
                        </el-form-item>
                        <el-form-item label="認証コード" prop="code">
                            <div class="yzm">
                                <el-input type="text" v-model="applyForm.code" id="code" placeholder="認証コードを入力してください"></el-input>
                                <span :disabled="disabled" @click="getVerificationCode">{{yzmtext}}</span>
                            </div>
                        </el-form-item>
                    </el-form>
                    <p class="agreement">
                        <el-checkbox v-model="checked">
                            <a :href="usercenter+'/agreement/registration?lang=jp'" target="_blank">「ユーザー登録・利用規約」</a> 及び
                            <a :href="usercenter+'/agreement/privacy?lang=jp'" target="_blank">「プライバシー保護規約」</a>
                            <b>に同意します</b>
                        </el-checkbox>
                    </p>
                    <div class="btn">
                        <span @click="$router.go(-1)">戻る</span>
                        <span @click="submit('applyForm')">完了してログイン</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Loading } from 'element-ui';
import { hexMD5 } from '@/assets/js/md5';
import qs from 'qs';
var interval = null;
export default {
    data () {
        var emails = (rule, value, callback) => {
                var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
                if(!reg.test(this.applyForm.email)){ 
                    callback(new Error('メールアドレスの形式が正しくありません')); 
                }  
            callback();
        };
        var password=(rule, value, callback) => {
            // 6-20个字符账号， 可包含数字、大小写字母或“-”
            var reg=/^[0-9A-Za-z\\-]{6,20}$/;
            if(!reg.test(value)){ 
                callback(new Error('6－20桁のユーザーIDをご記入ください。数字、英字の大文字と小文字、または 「-」 を含むことができます')); 
            }
            callback();
        };
        var confirmPassword=(rule, value, callback) => {
                if(!(value==this.applyForm.password)){ 
                    callback(new Error('2つのパスワードが一致しません')); 
                }
            callback();
        };
        var loginName=async (rule, value, callback) => {
            // 3-20个字符账号， 可包含数字、大小写字母或“-”
            var reg=/^[0-9A-Za-z\\-]{3,20}$/;
            if(!reg.test(value)){ 
                callback(new Error('3－20桁のユーザーIDをご記入ください。数字、英字の大文字と小文字、または 「-」 を含むことができます')); 
            }
            await this.$request({
                method:'post',
                data:qs.stringify({loginName:value}),
                headers:{
					'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                url:'/register/validate',
            }).then((res) => {
                if(res.data.code=='-100'){
                    callback(new Error('アカウントはすでに存在します')); //账号已存在
                }
                return true
            }).catch((err)=>{
                callback(new Error(err)); 
            })
            callback();
        };
        return {
            applyForm: {
                realName: "",
                identityId: "",
                loginName: "",
                password: "",
                confirmPassword:'',
                contactName: "",
                email:"",
                code:"",
            },
            applyRules: {
                realName:[
                    {required: true,message: "会社名をご記入ください",trigger: "blur"},
                    { min: 1, max: 100, message: '入力できる内容は100文字以内となります', trigger: 'blur' }
                ],
                identityId:[
                    {required: true,message: "会社法人等番号を入力してください",trigger: "blur"},
                    {min: 12, max: 12,message: "１２桁の会社法人等番号を入力してください",trigger: "blur"},
                ],
                loginName:[
                    {required: true, message: "ユーザーIDを入力してください", trigger: "blur"},
                    {validator:loginName, trigger: "blur"}
                ],
                password:[
                    {required: true,message: "パスワードを入力してください",trigger: "blur"},
                    {validator:password,trigger: "blur"}
                ],
                confirmPassword:[
                    {required: true,message: "パスワードを再入力してください",trigger: "blur"},
                    {validator: confirmPassword,trigger: "blur"}
                ],
                contactName: [
                    {required: true,message: "担当者氏名を入力してください",trigger: "blur"},
                    {min: 1,max: 15,message: "1〜15文字の長さ",trigger: "blur"}
                ],
                email: [
                    {required: true,message: "メールアドレスをご記入ください",trigger: "blur"},
                    {validator: emails,trigger: "blur"}
                ],
                code:[
                    {required: true,message: "認証コードを入力してください",trigger: "blur"}
                ],
            },           
            checked:false,
            disabled:false,
            yzmtext: "認証コード取得",
            currentTime: 60,
        }
    },
    components: {},
    computed: {
        usercenter(){
            return process.env.VUE_APP_USERCENTER
        }
    },
    created() {},
    mounted() {},
    methods: {
        getCode(options) {
            let that = this;
            let currentTime = that.currentTime
            interval = setInterval(function () {
                currentTime--;
                that.yzmtext='('+currentTime + 's)検証コードを再取得する'
                if (currentTime <= 0) {
                    clearInterval(interval)
                    that.yzmtext='検証コードを再取得する';
                    that.currentTime=60;
                    that.disabled=false;
                }
            }, 1000)
        },
        async getVerificationCode(){
            let reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
            if(!reg.test(this.applyForm.email)){ 
                this.$message.error('正しいメールボックス形式を入力してください');
                return false;
            }
            this.getCode();
            this.disabled=true;
            let newObj = JSON.parse(JSON.stringify(this.applyForm));
            newObj.password=hexMD5(newObj.password);
            delete newObj.confirmPassword;
            this.$request({
                method:'post',
                data:newObj,
                headers:{
                    'content-type': "application/json;charset=UTF-8"
                },
                url:'/register/sendEmail',
            }).then((res) => {
                if(res.data.code==-1){
                    that.$message.error('検証コードを送信できませんでした。メールアドレスをご確認ください');
                    clearInterval(interval)
                    that.yzmtext='検証コードを取得する';
                    that.currentTime=60;
                    that.disabled=false;
                    return false
                }
                this.$message({
                    message: '検証コードを送信しました',
                    type: 'success'
                });
            }).catch((err) => {
                console.log(err);
            })
        },
        submit(formName){
            let that=this;
            if(!this.checked){
                this.$message.error('「ユーザー登録・利用規約」「プライバシー保護規約」に同意し、チェックを入れてください')
                //('请先同意并勾选《用户注册与使用协议》和《隐私保护协议》')
                return false
            }
            that.$refs[formName].validate((valid) => {
                console.log(valid)
                if (valid) {
                    let loadingInstance = Loading.service();
                    let newObj = JSON.parse(JSON.stringify(this.applyForm));
                    newObj.password=hexMD5(newObj.password);
                    delete newObj.confirmPassword;
                    that.$request({
                        method:'post',
                        data:newObj,
                        headers:{
                            'content-type': "application/json;charset=UTF-8"
                        },
                        url:'/register/add',
                    }).then((res) => {
                        that.$nextTick(() => { 
                            loadingInstance.close();
                        });
                        if(res.data.code==-300){//验证码不正确
                            that.$message.error('認証コードが正しくありません')//('验证码不正确')
                        }else if(res.data.code==-100){//账户已存在
                            that.$message.error('アカウントはすでに存在します')//('账号已存在')
                        }else if(res.data.code==-1){//登录失败
                            that.$message.error('ログインに失敗しました。管理者にご連絡ください')//('登录失败，请联系客服')
                        }else{
                            that.$store.commit('setuserinfo',res.data.data);
                            that.$setlocalStorage('userinfo',res.data.data)
                            if(that.$route.query.redirect){ 
                                that.$router.replace({path:that.$route.query.redirect})  
                            }else{
                                that.$router.replace({name:"index"})
                            }
                        }
                    }).catch((err) => {
                        that.$nextTick(() => { 
                            loadingInstance.close();
                        });
                        console.log(err);
                    })
                }
            })
        },
    },
}

</script>
<style scoped lang='less'>
.header-wrap {
    width: 100%;
    min-width: 1200px;
    background: #6a91f0;
    border-bottom: 2px solid #ffffff;
}
.header {
    width: 1200px;
    margin: 0 auto;
    height: 100px;
    line-height: 100px;
}
.logo {
    display: flex;
    height: 100px;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
    a{
        display:block;
        cursor: pointer;
        img{
            display: block;
        }
    }
    .ngb{
        margin-left: 20px;
        height:27px;
        width: 72px;
    }
}
.banner{
    background:#6A91F0;
    min-height: 368px;
    position: relative;
    min-width: 1200px;
    width: 100%;
    img{
        width: 100%;
        position: absolute;
        left: 0;
        bottom:0;
        z-index: 1;
        right:0;
        margin:0 auto;
    }
}
.reg-cnt{
    position: relative;
    z-index: 2;
    width: 1200px;
    margin:0 auto;
    margin-top:-320px;
    .reg-body{
        width:980px;
        padding: 50px 0;
        margin:0 auto 30px;
        border-radius: 10px;
        background: #fff;
        box-shadow:0px 4px 10px 0px rgba(210,223,255,0.5);
        .logo2 {
            text-align: center;
            padding-top: 10px;
            margin-bottom: 24px;
            p {
                margin-top: 10px;
                font-size: 18px;
            }
        }
        .pageName{
            font-weight: bold;
            text-align: center;
            padding-bottom:20px;
            h3{
                font-size: 18px;
                color: #000;
                margin:0px 0 21px;
            }
            p{
                font-size: 12px;
                color: #FF3333;
            }
        }
        .form{
            width: 820px;
            margin: 0 auto;
            /deep/.el-form-item{
                width: 100%;
                display: flex;
                border-bottom: 2px solid #f0f0f0;
                position: relative;
                .el-form-item__label{
                    color: #A9A9A9;
                    font-size: 14px;
                    font-weight: bold;
                }
                .el-form-item__content{
                    flex: 1;
                    position:static;
                    .el-input{
                        .el-input__inner{
                            border: none;
                        }
                    }
                    .yzm{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        span{
                            height: 28px;
                            line-height: 28px;
                            padding: 0 16px;
                            display: block;
                            color: #fff;
                            background: #6a91f0;
                            border-radius: 3px;
                            cursor: pointer;
                            &[disabled] {
                                color: #fff;
                                background: #bcbcbc;
                                pointer-events: none;
                                cursor: inherit;
                                border-color: #bcbcbc;
                            }
                        }
                        .el-input{
                            flex: 1;
                        }
                    }
                }
                
            }
            /deep/.is-error{
                border-bottom: 2px solid rgb(250, 170, 170);
            }
            .agreement{
                font-weight: bold;
                margin-top: -4px;
                text-align: center;
                font-size: 14px;
                color: #A9A9A9;
                /deep/.el-checkbox{
                    .el-checkbox__label{
                        color: #A9A9A9;
                        font-size: 14px;
                        font-weight: bold;
                    }
                }
                b{
                    color: #A9A9A9;
                    font-size: 14px;
                    font-weight: bold;
                }
                a{
                    color: #A9A9A9;
                    font-size: 14px;
                    &:hover{
                        color: #6A91F0;
                    }
                }
                
            }
            .btn{
                padding-top: 39px;
                display: flex;
                justify-content: space-around;
                span{
                    cursor: pointer;
                    display: block;
                    width: 40%;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    color: #fff;
                    background: #6A91F0;
                    border-radius: 8px;
                    &:nth-child(1){
                        background: #d8dbe1;
                        color: #333;
                    }
                }
            }
        }
    }
}
</style>